import React from "react";
import { wordEllipsis } from "../../utils/strings";
import { useMediaQuery } from "react-responsive";

const CaseStudyCard = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div className="caseStudyCard">
      <div className="logo">
        <img src={content.logo.url} alt="logo" />
      </div>
      <div className={"content"}>{wordEllipsis(content.content, isMobile ? 220 : 190)}</div>
      <div className="bottom">
        <span className="author">{content.author}</span>
        {content.location && <span className="location">, {content.location}</span>}
      </div>
    </div>
  );
};

export default CaseStudyCard;
